import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getEntityHistory = createAsyncThunk(
  "History/get",
  async (payload, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      params.append("entityType", payload.entityType);
      params.append("entityId", payload.entityId);
      params.append("pageNumber", payload.pageNumber || 1);
      params.append("pageSize", payload.pageSize || 10);

      const { data } = await axios.get(
        `${API_URL.HISTORY.SLUG}?${params.toString()}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const historySlice = createSlice({
  name: "history",
  initialState: {
    history_list: [],
    history_loading: false,
    history_error: null,
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  },
  reducers: {
    resetHistory(state) {
      state.history_list = [];
      state.history_loading = false;
      state.history_error = null;
      state.pagination = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEntityHistory.pending, (state) => {
        state.history_loading = true;
        state.history_error = null;
      })
      .addCase(getEntityHistory.fulfilled, (state, action) => {
        state.history_list = action.payload?.items || [];
        state.pagination = {
          current: action.payload?.pageNumber || 1,
          pageSize: action.payload?.pageSize || 10,
          total: action.payload?.totalCount || 0,
        };
        state.history_loading = false;
      })
      .addCase(getEntityHistory.rejected, (state, action) => {
        state.history_error = action.payload;
        state.history_loading = false;
      });
  },
});

export const { resetHistory } = historySlice.actions;
export default historySlice.reducer;
